import { render, staticRenderFns } from "./trainstat.vue?vue&type=template&id=9496945a&scoped=true&"
import script from "./trainstat.vue?vue&type=script&lang=js&"
export * from "./trainstat.vue?vue&type=script&lang=js&"
import style0 from "./trainstat.vue?vue&type=style&index=0&id=9496945a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9496945a",
  null
  
)

export default component.exports